import { h } from 'preact';

export const Close = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    aria-label={window.TMW.Strings.icons.close}
    aria-hidden="true"
  >
    <title>{window.TMW.Strings.icons.close}</title>
    <path
      d="M1.45545 1.85224L14.8154 15.2122M1 15.5L15 1.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const CloseV2 = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-label={window.TMW.Strings.icons.close}
    aria-hidden="true">
      <title>{window.TMW.Strings.icons.close}</title>
    <path d="M12 4L4 12M4 4L12 12" stroke="#402518" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const Angle = () => (
  <svg
    width="12"
    height="7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 7"
  >
    <title>{window.TMW.Strings.icons.chevronArrow}</title>
    <path
      d="m11 5.625-5-5-5 5"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Minus = () => (
  <svg width="9" height="1" viewBox="0 0 9 1" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>{window.TMW.Strings.icons.minus}</title>
    <line x1="0.636717" y1="0.410158" x2="7.94137" y2="0.410158" stroke="#402518" strokeWidth="0.66406" strokeLinecap="round"/>
  </svg>
);

export const Plus = () => (
  <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>{window.TMW.Strings.icons.plus}</title>
    <line x1="4.22265" y1="1.08984" x2="4.22265" y2="8.3945" stroke="#402518" strokeWidth="0.66406" strokeLinecap="round"/>
    <line x1="0.636717" y1="4.8086" x2="7.94137" y2="4.8086" stroke="#402518" strokeWidth="0.66406" strokeLinecap="round"/>
  </svg>
);
